import FS from '../FetchService';

export default class GradeService {
  static fetch() {
    return FS.get('/grades');
  }
}


// WEBPACK FOOTER //
// ./src/services/users/GradeService.js